/** GET /api/app/pick-list/pick-list-by-code-select-item — generic SelectListItem from the backend pick-list service. */
export interface PickListItemDto {
  /** Stable identifier (typically a GUID). Used as the `<option value>`. */
  value: string;
  /** Display label (already localized by the server). */
  text: string;
  disabled: boolean;
  selected: boolean;
  group: PickListItemGroupDto | null;
}

export interface PickListItemGroupDto {
  name: string;
  disabled: boolean;
}

/** Known pick-list codes used across reporting dashboards. */
export const PICK_LIST_CODES = {
  teacherRole: 'TeacherRole',
  teacherQualification: 'TeacherQualification',
  programs: 'Programs',
} as const;

export type PickListCode = (typeof PICK_LIST_CODES)[keyof typeof PICK_LIST_CODES];
